import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

import { useDispatch } from "../redux/hooks";
import { setManagementLinks } from "../redux/slices/permsSlice";
import { usePostApi } from "./usePostApi";
/**
 * Custom hook to handle user logout functionality.
 *
 * @returns A function to log out the user.
 */
export const useLogout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { post } = usePostApi();

  const logout = useCallback(async () => {
    dispatch(setManagementLinks(undefined));

    await post({ request: "logout" });
    localStorage.removeItem("authData");
    localStorage.removeItem("logoutModalStart");
    navigate("/login");
  }, [navigate, post, dispatch]);

  return logout;
};
